// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-card {
  font-size: 16px;
  background: #fff;
  border-radius: 6px;
  width: 100%;
  padding: 34px;
}

textarea {
  min-height: 200px;
}

.aptsi-table-container {
  max-height: 410px; /* Adjust as needed */
  overflow-y: auto;
}

.inp {
  width: 560px;
}

.bar-section {
  max-width: 1400px;
  background: #ffffff;
  border-radius: 3px;
  padding: 0; /* Remove padding to eliminate extra space */
  margin-top: 5px;
}

.bar-section .row {
  margin: 0; /* Remove default row margin */
}

.bar-section .tab-column {
  background-color: #A4B4BF; /* Default background color */
  color: white; /* Default text color */
  cursor: pointer;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 3px;
  transition: background-color 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/ruleset/node/node-update/node-update.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,iBAAA,EAAA,qBAAA;EACA,gBAAA;AAEF;;AAEA;EACI,YAAA;AACJ;;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA,EAAA,4CAAA;EACA,eAAA;AAAJ;;AAGE;EACE,SAAA,EAAA,8BAAA;AAAJ;;AAGE;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,sCAAA;AAAJ","sourcesContent":[".column-card {\n  font-size: 16px;\n  background: #fff;\n  border-radius: 6px;\n  width: 100%;\n  padding: 34px;\n}\ntextarea {\n  min-height: 200px;\n}\n\n.aptsi-table-container {\n  max-height: 410px; /* Adjust as needed */\n  overflow-y: auto;\n}\n\n\n.inp {\n    width: 560px;\n    \n  }\n\n  .bar-section {\n    max-width: 1400px;\n    background: #ffffff;\n    border-radius: 3px;\n    padding: 0; /* Remove padding to eliminate extra space */\n    margin-top: 5px;\n  }\n  \n  .bar-section .row {\n    margin: 0; /* Remove default row margin */\n  }\n  \n  .bar-section .tab-column {\n    background-color: #A4B4BF; /* Default background color */\n    color: white; /* Default text color */\n    cursor: pointer;\n    text-align: center;\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid rgb(204, 202, 202);\n    border-radius: 3px;\n    transition: background-color 0.3s ease;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
